export default __webpack_public_path__ + "static/media/AJAY TAMMULURI.9eeb3f0e.jpeg";